import { Fetch } from 'lib';

type RequestResponses = {};

type RequestParameters = {
  id: string;
};

const sendUserForgetPasswordLink = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminUser/sendUserForgetPasswordLink',
    method: 'POST',
    params,
  });

export { sendUserForgetPasswordLink };
